export const updateSearch = (obj) => {
  return { type: 'UPDATE_SEARCH', payload: obj };
};
export const updateSearchResults = (results) => {
  return { type: 'UPDATE_SEARCH_RESULTS', payload: results };
};
export const updateSearchType = (type) => {
  return { type: 'UPDATE_SEARCH_TYPE', payload: type };
};
export const updateSearchTerm = (term) => {
  return { type: 'UPDATE_SEARCH_TERM', payload: term };
};
export const updateSearchIsOpen = (isOpen) => {
  return { type: 'UPDATE_SEARCH_IS_OPEN', payload: isOpen };
};
export const updateSearchSelected = (isSelected) => {
  return { type: 'UPDATE_SEARCH_SELECTED', payload: isSelected };
};
